import { useEffect, useState } from "react";
import { Gift, Copy, Check, Users } from "lucide-react";
import api from "../lib/api";

/**
 * ReferralCard — invite friends and both get a FREE spin. Renders in Profile /
 * Wallet pages. Uses username as the referral code.
 */
export default function ReferralCard() {
  const [info, setInfo] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    api.get("/me/referral").then(r => setInfo(r.data)).catch(() => {});
  }, []);

  if (!info) return null;
  const url = `${window.location.origin}/signup?ref=${info.code}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    } catch { /* ignore */ }
  };
  const share = async () => {
    if (navigator.share) {
      try { await navigator.share({ title: "Join Hifireels", text: "Join Hifireels — we both get a FREE spin on the wheel!", url }); return; } catch { /* fall through */ }
    }
    copy();
  };

  return (
    <div className="rounded-2xl p-4 bg-gradient-to-br from-[#FBBF24]/20 via-[#FF7A00]/15 to-[#FF2A5F]/15 border border-[#FBBF24]/30" data-testid="referral-card">
      <div className="flex items-center gap-2 mb-2">
        <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#FBBF24] to-[#FF7A00] flex items-center justify-center">
          <Gift className="w-4 h-4 text-black"/>
        </div>
        <div>
          <div className="font-outfit font-extrabold text-sm">Invite friends · both get 1 FREE spin</div>
          <div className="text-[11px] text-white/60">You've invited <b className="text-white">{info.referral_count}</b> friend{info.referral_count === 1 ? "" : "s"} · <b className="text-[#FBBF24]">{info.free_spins}</b> free spins waiting</div>
        </div>
      </div>
      <div className="flex items-center gap-2 mt-3">
        <div className="flex-1 min-w-0 px-3 py-2 rounded-xl bg-black/30 border border-white/10 text-[11px] font-mono text-white/85 truncate" data-testid="referral-link">{url}</div>
        <button onClick={copy} data-testid="referral-copy"
          className="px-3 py-2 rounded-xl bg-white/10 border border-white/15 text-xs font-bold flex items-center gap-1 active:scale-95">
          {copied ? <><Check className="w-3.5 h-3.5 text-emerald-400"/>Copied</> : <><Copy className="w-3.5 h-3.5"/>Copy</>}
        </button>
        <button onClick={share} data-testid="referral-share"
          className="px-3 py-2 rounded-xl bg-gradient-to-r from-[#FF2A5F] to-[#FF7A00] text-white text-xs font-extrabold flex items-center gap-1 active:scale-95">
          <Users className="w-3.5 h-3.5"/>Share
        </button>
      </div>
    </div>
  );
}
